import React from 'react';
import PropTypes from 'prop-types';
import { colors } from "../../styleguide";
import styled, { keyframes } from 'styled-components';
var DEFAULT_OPACITY = 0.3;
var petalAnimation = keyframes(["from{opacity:1;}to{opacity:", ";}"], DEFAULT_OPACITY);
var Petal = styled.line.withConfig({
  displayName: "SvgSpinner__Petal",
  componentId: "sc-1xt3dx9-0"
})(["opacity:", ";stroke:", ";stroke-width:", ";stroke-linecap:round;animation:", " ", "s infinite;animation-delay:", "s;"], DEFAULT_OPACITY, function (props) {
  return props.color;
}, function (props) {
  return props.width;
}, petalAnimation, function (props) {
  return props.animationLength;
}, function (props) {
  return props.animationDelay;
});

function SvgSpinner(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 100 : _ref$size,
      _ref$numPetals = _ref.numPetals,
      numPetals = _ref$numPetals === void 0 ? 12 : _ref$numPetals,
      _ref$petalWidth = _ref.petalWidth,
      petalWidth = _ref$petalWidth === void 0 ? 5 : _ref$petalWidth,
      _ref$animationLength = _ref.animationLength,
      animationLength = _ref$animationLength === void 0 ? 1 : _ref$animationLength,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors.grey800 : _ref$color;
  var cx = 50;
  var cy = cx;
  var innerRadius = 25;
  var outerRadius = 45;
  var petals = Array.from({
    length: numPetals
  }, function (_, i) {
    var t = i / numPetals;
    var radians = t * Math.PI * 2.0;
    var cos = Math.cos(radians);
    var sin = Math.sin(radians);

    var round = function round(num) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      return parseFloat(num.toFixed(precision));
    };

    var x1 = round(cx + cos * innerRadius);
    var y1 = round(cy + sin * innerRadius);
    var x2 = round(cx + cos * outerRadius);
    var y2 = round(cy + sin * outerRadius);
    return /*#__PURE__*/React.createElement(Petal, {
      key: i,
      color: color,
      x1: x1,
      y1: y1,
      x2: x2,
      y2: y2,
      width: petalWidth,
      className: "petal",
      animationDelay: t * animationLength,
      animationLength: animationLength
    });
  });
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100 100",
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    role: "presentation"
  }, petals);
}

SvgSpinner.propTypes = process.env.NODE_ENV !== "production" ? {
  numPetals: PropTypes.number,
  petalWidth: PropTypes.number,
  animationLength: PropTypes.number,
  color: PropTypes.string,
  size: PropTypes.number
} : {};
export default SvgSpinner;
//# sourceMappingURL=SvgSpinner.js.map